
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import Form1 from "@/views/scanforoutbound_getoff/Form1.vue";
  import Form2 from "@/views/scanforoutbound_getoff/Form2.vue";
  import Scan from "@/views/components/Scan/Scan.vue";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import TableHeader from "@/views/scanforoutbound_getoff/TableHeader.vue";
  import Counting from "@/views/components/Counting/Counting.vue";
  import RankingList from "@/views/components/RankingList/index.vue";
  import config from "./config";
  import {CountingVo} from "@/views/components/Counting/CountingVo";
  import {ApiQueryType} from "@/common/glboalconstant";
  import {SoundPlayer} from "@/common/SoundPlayer";
  import {QueueGetOffEntity} from "@/common/Vo/QueueGetOffEntity";
  import Enumerable from "linq";
  import fa from "element-ui/src/locale/lang/fa";
  import el from "element-ui/src/locale/lang/el";
  import DEFAULT_TIMEOUT_INTERVAL = jasmine.DEFAULT_TIMEOUT_INTERVAL;
  import {parseTime, removeItem} from "@/utils";
  import en from "element-ui/src/locale/lang/en";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";


  @Component({
    name: "ScanForOutboundGetoffSahpe1",
    components: {
      RankingList,
      Counting,
      TableHeader,
      YtoTable,
      Scan,
      Form2,
      Form1
    }
  })
  export default class extends Vue {
    @Prop() private tableItems!: QueueGetOffEntity[];
    @Prop() private sendCountVo: sendCountVo;
    @Prop() private buttonVo: ButtonListVo;

    private created(): void {
    }

    private mounted(): void {
    }

    @Prop() private msg: string;
    @Prop() private ioTypes: ioTypes_Array_Data[];


    private ytoRowDbCLick(row, column, event) {
      this.$emit('ytoRowDbCLick', row, column, event);
    }

    private config = config;
    @Prop() private f1: OnCodeGetReqVo;


    public ytoCode: string = '';


    private ytocodeget(e) {
      this.$emit('ytocodeget', this.ytoCode, ...arguments)
    }

    @Prop() private CountVo: CountingVo;

    private delClick(): void {
      let el: any = this.$refs.ytoTable;
      let row = el.getSelectRow();
      if (row) {
        this.$emit('delClick', row)
      } else {
        this.$message.error("请先选择一条数据")
      }
    }

    @Prop() private scacInputDisable: boolean;

    private modifyClick(): void {
      this.$emit('modifyClick', ...arguments);
    }

    private saveClick(): void {
      this.$emit('saveClick', ...arguments)
    }

    private submitClick(): void {
      this.$emit('submitClick', ...arguments);
    }
  }
